import moment from 'moment';
import i18n from '@/i18n/index';

export default () => {
  const now = moment().format('YYYY-MM-DD HH:mm:ss');
  const nowUtc = new Date().toISOString().replace('T',' ').substr(0,19);

  return {
    name: `Flow (${now})`,
    countryId: 0,
    redirectMode: <any> null,
    redirectDomainId: <any> null,
    rules: [
      {
        name: 'Default',
        default: true,
        conditions: {},
        status: 'active',
        paths: [
          {
            name: 'Path 1',
            weight: 100,
            percent: 100,
            directLinking: false,
            status: 'active',
            landings: <any[]> [],
            offers: <any[]> [],
            redirectMode: '302',
            redirectModeOffers: '302'
          }
        ]
      }
    ],
    status: 'active',
    created: nowUtc,
    updated: nowUtc,
    tags: <any[]> [],
    nameFull: `Global - Flow (${now})`,
    workspaceId: <any> null
  }
};
